module.exports = __webpack_public_path__ + "img/kim-phat.129c4619.png";